import { SET_INVENTORY_STATUS } from "./inventoryTypes";

export const setInventoryStatus = (inventoryStatus: any) => ({
    type: SET_INVENTORY_STATUS,
    payload: inventoryStatus,
});